<template lang="pug">
.grafico-linha(style='margin-top: 50px')
    ApexCharts.component.apexcharts-canvas(
        type='line',
        height='450',
        :options='chartOptions',
        :series='series'
    )
</template>
<script>
import ApexCharts from 'vue-apexcharts';

export default {
    name: 'GraficoLinhasDashboard',
    components: {
        ApexCharts
    },
    props: {
        series: {
            type: Array,
            required: true,
            default: () => []
        },
        categories: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    computed: {
        chartOptions: {
            get() {
                const categorias_ = this.categories;
                return {
                    chart: {
                        height: 400,
                        fontFamily: 'Roboto, sans-serif',
                        type: 'line',
                        zoom: {
                            enabled: false
                        },
                        toolbar: {
                            show: false
                        }
                    },
                    legend: {
                        position: 'top',
                        horizontalAlign: 'center',
                        floating: true,
                        offsetY: 0,
                        offsetX: 0
                    },
                    colors: [
                        '#859FC5',
                        '#607D8B',
                        '#EDAB1D',
                        '#359138',
                        '#757575',
                        '#DC362E'
                    ],
                    stroke: {
                        curve: 'smooth'
                    },
                    tooltip: {
                        followCursor: true
                    },
                    markers: {
                        size: 5,
                        colors: undefined,
                        strokeColors: '#fff',
                        strokeWidth: 2,
                        strokeOpacity: 0.9,
                        strokeDashArray: 0,
                        fillOpacity: 1,
                        discrete: [],
                        shape: 'circle',
                        radius: 2,
                        offsetX: 0,
                        offsetY: 0,
                        onClick: undefined,
                        onDblClick: undefined,
                        showNullDataPoints: true,
                        hover: {
                            size: undefined,
                            sizeOffset: 2
                        }
                    },
                    grid: {
                        borderColor: '#BDBDBD',
                        strokeDashArray: 2,
                        show: true,
                        position: 'back',
                        xaxis: {
                            lines: {
                                show: true
                            }
                        },
                        yaxis: {
                            lines: {
                                show: true
                            }
                        },
                        row: {
                            colors: undefined,
                            opacity: 0.5
                        },
                        column: {
                            colors: undefined,
                            opacity: 0.5
                        },
                        padding: {
                            top: 20,
                            right: 0,
                            bottom: 0,
                            left: -80
                        }
                    },
                    yaxis: {
                        labels: {
                            align: 'left',
                            maxWidth: 150,
                            offsetX: -90,
                            offsetY: 2,
                            style: {
                                color: '#3B3B3B',
                                fontSize: '12px',
                                fontFamily: 'Roboto, sans-serif',
                                fontWeight: 500
                            },
                            formatter: function (val) {
                                return val.toLocaleString('pt-BR', {
                                    maximumFractionDigits: 0
                                });
                            }
                        },
                        title: {
                            text: this.$t('laudos.tituloYAxisGraficoLinha'),
                            align: 'left',
                            offsetX: 65,
                            offsetY: -210,
                            margin: 10,
                            style: {
                                fontSize: '14px',
                                fontWeight: 500
                            },
                            rotate: -360
                        }
                    },
                    xaxis: {
                        categories: categorias_,
                        labels: {
                            style: {
                                color: '#3B3B3B',
                                fontSize: '14px',
                                fontFamily: 'Roboto, sans-serif',
                                fontWeight: 500
                            }
                        }
                    }
                };
            },
            set() {}
        }
    },
    data() {
        return {};
    }
};
</script>
<style scoped lang="scss"></style>
